<template>
  <SimpleDataCard
      :title="'Toplam Tedarikçi'"
      :data="reportCompanyData.totalSupplier.toString()"
      :description="'Tüm Zamanlar'"
      :loading="reportCompanyDataLoading"
  >

  </SimpleDataCard>
</template>

<script>

import SimpleDataCard from "@/components/dashboard/SimpleDataCard";
import {numberConverter} from "../../../../helpers";
import {mapState} from "vuex";

export default {
  name: "ToplamTedarikci",
  components: {
    SimpleDataCard
  },
  computed: {
    ...mapState("dashboard",["reportCompanyData","reportCompanyDataLoading"])
  },
  methods: {
    numberConverter
  }
}
</script>

<style scoped>

</style>